import { OrganizationExternalProvidersTab } from '@/pages/Organizations/ExternalProviders';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { organizationId } = Route.useParams();
  return <OrganizationExternalProvidersTab organizationId={organizationId} />;
};

export const Route = createFileRoute('/_auth/organizations/$organizationId/external-providers')({
  component: RouteComponent,
});
